import React from 'react';
import ReactMarkdown from 'react-markdown';
export const renderPreviewText = (text) => React.createElement(ReactMarkdown, { skipHtml: true }, text);
export const getLatestMessagePreview = (channel, t, userLanguage = 'en') => {
    const latestMessage = channel.state.messages[channel.state.messages.length - 1];
    const previewTextToRender = latestMessage?.i18n?.[`${userLanguage}_text`] ||
        latestMessage?.text;
    if (!latestMessage) {
        return t('Nothing yet...');
    }
    if (latestMessage.deleted_at) {
        return t('Message deleted');
    }
    if (previewTextToRender) {
        const renderedText = renderPreviewText(previewTextToRender);
        return renderedText;
    }
    if (latestMessage.command) {
        return `/${latestMessage.command}`;
    }
    if (latestMessage.attachments?.length) {
        return t('🏙 Attachment...');
    }
    return t('Empty message...');
};
const getChannelDisplayInfo = (info, channel, currentUser) => {
    if (channel.data?.[info])
        return channel.data[info];
    const members = Object.values(channel.state.members);
    if (members.length !== 2)
        return;
    const otherMember = members.find((member) => member.user?.id !== currentUser?.id);
    return otherMember?.user?.[info];
};
export const getDisplayTitle = (channel, currentUser) => getChannelDisplayInfo('name', channel, currentUser);
export const getDisplayImage = (channel, currentUser) => getChannelDisplayInfo('image', channel, currentUser);
